class e extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.9998 16L23.9998 23L22.5898 21.59L28.1698 16L22.5898 10.41L23.9998 9L30.9998 16Z" fill="#16191D"></path><path d="M1 16L8 9L9.41 10.41L3.83 16L9.41 21.59L8 23L1 16Z" fill="#16191D"></path><path d="M17.6388 6.00092L12.4185 25.4836L14.3503 26.0013L19.5707 6.51856L17.6388 6.00092Z" fill="#16191D"></path></svg>';
  }
}
const t = "pwc-icon-code";
customElements.get(t) || customElements.define(t, e);
